module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 38
// module chunks = 0